type FeedbackEnvironmentInfoProps = {
  browser: string
  platform: string
  screenResolution: string
}

export function FeedbackEnvironmentInfo({ browser, platform, screenResolution }: FeedbackEnvironmentInfoProps) {
  return (
    <div className="text-xs text-muted-foreground bg-muted rounded-md p-3 space-y-0.5">
      <p>Browser: {browser}</p>
      <p>Platform: {platform}</p>
      <p>Screen: {screenResolution}</p>
    </div>
  )
}
